import React, { useEffect, useReducer, useState } from 'react'
import { Button } from '@/Components/ui/button'
import Datatable from '@/Components/Common/Datatable'
import { Input } from '@/Components/ui/input'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDebounce } from 'use-debounce'
import Constant from '@/utils/Constant'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import { SquarePlus } from 'lucide-react'
import DataTableEnumType from '@/Enums/DataTableTypeEnum'
import { useAuth } from '@/Context/AuthContext'
import RequiredPermission from '@/assets/data/RequiredPermission'
import { checkPermission } from '@/utils/helper'
import DeleteConfirmationTypeEnum from '@/Enums/DeleteConfirmationTypeEnum'
import MitemService from '@/Service/MitemService'
import MitemColumns from './MitemColumns'
import ConfirmationPopup from '@/Components/Common/ConfirmationPopup'

const Mitem = () => {
    const { userInfo } = useAuth()
    const navigate = useNavigate()
    const [event, updateEvent] = useReducer((prev, next) => ({ ...prev, ...next }), {
        totalmItemCount: 0,
        isDataFetching: false,
        deleteConfirmationOpen: false,
        mItems: [],
        deleteId: [],
        allcheck: false,
        mItemSearch: '',
        isOpen: false,
        queryParam: {
            page: 1,
            mitem: '',
        },
    })
    const [debouncedmItemSearch] = useDebounce(event.mItemSearch, Constant.DEBOUNCE_DELAY)
    const location = useLocation()
    const getMitem = async (page = 1) => {
        updateEvent({ isDataFetching: true, mItems: [] })
        try {
            const resp = await MitemService.getMitems(event.queryParam)
            if (resp.data.success) {
                updateEvent({ mItems: resp.data.data, totalmItemCount: resp.data.pagination.total_record })
            }
        } catch (err) {
            console.log("in error",err)
        }
        updateEvent({ isDataFetching: false })
    }
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        getMitem()
    }, [event.queryParam.page, event.queryParam.mitem])

    useEffect(() => {
        updateEvent({
            queryParam: {
                ...event.queryParam,
                mitem: debouncedmItemSearch,
            },
        })
    }, [debouncedmItemSearch])

    const createHCHB = () => {
        navigate(`/setup/mitem/new`)
    }

    const delete_mitem = async (action) => {
        if (!action) {
            updateEvent({ deleteConfirmationOpen: false })
            return false
        }
        try {
            const resp = await MitemService.deleteMitem(event.deleteId)
            if (resp.data.success) {
                getMitem()
            }
            updateEvent({ deleteId: [], allcheck: false })
        } catch (err) {}
        updateEvent({ deleteConfirmationOpen: false })
    }
    return (
        <div>
            <HeaderCard>
                <div className="flex justify-between items-center">
                    {checkPermission(RequiredPermission.PROCESS.CREATE, userInfo.roles) && (
                        <Button className="bg-primary-btn hover:bg-primary-purpal" onClick={createHCHB}>
                            <SquarePlus />
                            Add Mitem
                        </Button>
                    )}

                    {checkPermission(RequiredPermission.PROCESS.DELETE, userInfo.roles) && event.deleteId.length > 0 && (
                        <Button
                            variant="outline"
                            onClick={() => updateEvent({ deleteConfirmationOpen: true })}
                            className={`ml-[10px] ${event.deleteId.length > 0 ? 'block' : 'hidden'}`}
                        >
                            Delete
                        </Button>
                    )}
                </div>
            </HeaderCard>
            <ConfirmationPopup
                open={event.deleteConfirmationOpen}
                message="Are you sure you want to delete this permanently?"
                type={DeleteConfirmationTypeEnum.DELETE}
                setOpen={() => updateEvent({ deleteConfirmationOpen: !event.deleteConfirmationOpen })}
                handleAction={delete_mitem}
            />
            <BodyCard>
                <div className="w-full my-2 grid grid-cols-4 gap-3">
                    <Input type="text" value={event.mItem} onChange={(e) => updateEvent({ mItemSearch: e.target.value })} placeholder="Mitem" />
                </div>
                <Datatable
                    columns={MitemColumns()}
                    data={event.mItems}
                    totalDataCount={event.totalmItemCount}
                    allcheck={event.allcheck}
                    updateEvent={updateEvent}
                    deleteId={event.deleteId}
                    loading={event.isDataFetching}
                    type={DataTableEnumType.MITEM}
                />
            </BodyCard>
        </div>
    )
}

export default Mitem
